import { AttendanceServiceEnum } from "../../attendance/enums/attendance-cau.enum";

export class StudentAttendanceMonitorItem {
    index: number;
    studentId: number;
    studentName: string;
    serviceId: number;
    serviceName: string;
    schoolarshipName: string;
    attendanceState: AttendanceServiceEnum;
    attendanceService: number;
    edited: boolean;
    schoolarCourse: string;
    schoolarCourseId: number;
}